
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/get-status",
      function () {
        return require("private-next-pages/docs/how-to/get-status.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/get-status"])
      });
    }
  